import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { firestore } from '../Firebase';
import HeaderClient from './HeaderClient';
import { BeatLoader } from 'react-spinners';

const ClientVideoList = () => {
  const navigate = useNavigate();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [singleVideoId, setSingleVideoId] = useState('');
  const [hasConferenceModeOn, setHasConferenceModeOn] = useState(true);
  const [featuresLoaded, setFeaturesLoaded] = useState(false);
  const [customizationLoaded, setCustomizationLoaded] = useState(false);

  useEffect(() => {
    const unsubscribeFeatures = firestore
      .collection('settings')
      .doc('features')
      .onSnapshot(
        (doc) => {
          setHasConferenceModeOn(
            doc.exists ? Boolean(doc.data().hasConferenceModeOn) : true
          );
          setFeaturesLoaded(true);
        },
        (error) => {
          console.error('Error fetching features:', error);
          setFeaturesLoaded(true);
        }
      );

    const unsubscribeCustomization = firestore
      .collection('settings')
      .doc('customization')
      .onSnapshot(
        (doc) => {
          setSingleVideoId(doc.exists ? doc.data().singleVideoId || '' : '');
          setCustomizationLoaded(true);
        },
        (error) => {
          console.error('Error fetching customization:', error);
          setCustomizationLoaded(true);
        }
      );

    return () => {
      unsubscribeFeatures();
      unsubscribeCustomization();
    };
  }, []);

  const settingsLoaded = featuresLoaded && customizationLoaded;

  useEffect(() => {
    if (settingsLoaded && !hasConferenceModeOn && singleVideoId) {
      navigate(`/questions/${singleVideoId}`, { replace: true });
    }
  }, [settingsLoaded, hasConferenceModeOn, singleVideoId, navigate]);

  useEffect(() => {
    const unsubscribe = firestore.collection('videos').onSnapshot(
      (snapshot) => {
        const videoData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setVideos(videoData);
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching videos:', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return (
    <Container fluid>
      <Row>
        <HeaderClient />
      </Row>
      <Row className="mt-4">
        <Col>
          {loading || !settingsLoaded ? (
            <div className="d-flex justify-content-center mt-5">
              <BeatLoader color="#36d7b7" />
            </div>
          ) : (
            <Row xs={1} md={2} lg={3} className="g-4">
              {videos.map((video) => (
                <Col key={video.id}>
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <Card.Title>{video.title || 'Untitled Video'}</Card.Title>
                      <Link
                        to={`/questions/${video.id}`}
                        className="btn btn-primary"
                      >
                        Load the Questions
                      </Link>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
              {videos.length === 0 && !loading && (
                <Col>
                  <p>No videos found.</p>
                </Col>
              )}
            </Row>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ClientVideoList;
